<template>
  <div v-loading="loading" class="main-frame">
    <el-container>
      <el-header class="banner-head" height="60px">
        <div class="head-info">
          <el-form :inline="true" @submit.native.prevent>
            <el-form-item label="类型:">
              <el-select v-model="type_id" clearable placeholder="请选择" loading-text="加载中...">
                <el-option key="type-all" label="所有" value></el-option>
                <el-option
                  v-for="item in type_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态:">
              <el-select v-model="page_status" clearable placeholder="请选择" loading-text="加载中...">
                <el-option
                  v-for="item in $common.CommonStatusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键字:">
              <el-input
                v-model="search_key"
                clearable
                size="medium"
                placeholder="请输入关键字"
                @keyup.enter.native="getCategoryList"
              ></el-input>
            </el-form-item>
            <el-button
              class="top-button"
              size="medium"
              type="primary"
              round
              @click="getCategoryList"
            >过滤</el-button>
            <el-button
              class="top-button"
              size="medium"
              type="primary"
              round
              @click="newCategoryOnClick"
            >添加</el-button>
          </el-form>
        </div>
      </el-header>
      <el-main>
        <el-table
          :data="content_category_list"
          style="width: 100%"
          :cell-style="$common.tableStyle"
          :header-cell-style="$common.tableStyle"
          border
          default-expand-all
        >
          <el-table-column label="#" width="80">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.$index + 1 }}</p>
            </template>
          </el-table-column>
          <el-table-column label="权重" width="80">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.number }}</p>
            </template>
          </el-table-column>
          <el-table-column label="名称">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.name }}</p>
            </template>
          </el-table-column>
          <el-table-column label="别名">
            <template slot-scope="scope">
              <p style="font-weight: bold">{{ scope.row.alias }}</p>
            </template>
          </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              <p style="font-weight: bold">
                {{
                type_map.get(scope.row.type_id)
                ? type_map.get(scope.row.type_id).name
                : "无"
                }}
              </p>
            </template>
          </el-table-column>
          <el-table-column label="PC端图标" width="160">
            <template slot-scope="scope">
              <el-image
                fit="scale-down"
                style="width: 100px; height: 100px"
                :src="scope.row.pc_image_url + $common.K_QINIU_IMAGE_SMALL_END_200"
                :preview-src-list="[scope.row.pc_image_url]"
                lazy
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="WAP端图标" width="160">
            <template slot-scope="scope">
              <el-image
                fit="scale-down"
                style="width: 100px; height: 100px"
                :src="scope.row.wap_image_url + $common.K_QINIU_IMAGE_SMALL_END_200"
                :preview-src-list="[scope.row.wap_image_url]"
                lazy
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <el-tag
                style="font-weight: bold"
                :type="$common.CommonStatusList[scope.row.status].tag"
                effect="dark"
              >{{ $common.CommonStatusList[scope.row.status].name }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button style="color: #03aef9" @click="editModelOnclick(scope.row)" type="text">编辑</el-button>
              <el-button
                style="color: #f03c69"
                @click="removeModelOnclick(scope.row)"
                type="text"
              >移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer class="footer-info">
        <el-pagination
          style="margin-top: 15px"
          background
          layout="prev, pager, next, jumper"
          :page-size="page_size"
          :pager-count="9"
          :total="page_total"
          :current-page="page_number"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>

<script>
export default {
  name: "ContentCategoryListView",
  data() {
    return {
      loading: false,
      search_key: "",
      type_id: "",
      type_list: [],
      type_map: {},
      page_status: 0,
      page_total: 0,
      page_size: 20,
      page_number: 1,
      content_category_list: []
    };
  },
  created() {
    this.type_map = new Map();
    this.getTypeList();
    this.getCategoryList();
  },
  methods: {
    getTypeList() {
      let _me = this;
      let key = "contentTypeList";
      let val = _me.$common.getGlobalStorage(key);
      if (val) {
        _me.type_list = val;
        for (let i of _me.type_list) {
          _me.type_map.set(i.id, i);
        }
        return;
      }
      let params = {
        status: 1,
        page_size: -1,
        page_number: 1,
        sort_fields: ""
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/content/admin/type/find/list", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.type_list = res.data.array === undefined ? [] : res.data.array;
            for (let i of _me.type_list) {
              _me.type_map.set(i.id, i);
            }
            _me.$common.setGlobalStorage(key, _me.type_list);
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || "获取数据失败",
            type: "error"
          });
        });
    },
    getCategoryList(page) {
      let _me = this;
      if (page) {
        _me.page_number = page;
      }

      let params = {
        key: _me.search_key,
        type_id: _me.type_id,
        status: _me.page_status,
        page_size: _me.page_size,
        page_number: _me.page_number,
        sort_fields: ""
      };
      _me.loading = true;
      _me.$common
        .httpPost("/api/content/admin/category/find/list", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.content_category_list =
              res.data.array === undefined ? [] : res.data.array;
            _me.page_total = res.data.total;
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || "获取数据失败",
            type: "error"
          });
        });
    },
    newCategoryOnClick() {
      let _me = this;
      if (_me.type_list && _me.type_list.length > 0) {
        this.$router.push("content-category-detail");
      } else {
        _me.$message.error("请先添加文章类型");
      }
    },
    editModelOnclick(model) {
      this.$router.push("content-category-detail?id=" + model.id);
    },
    removeModelOnclick(model) {
      let _me = this;
      _me
        .$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          _me.removeItem(model);
        })
        .catch(() => {
          // eslint-disable-next-line no-console
          console.log("取消删除");
        });
    },
    removeItem(model) {
      let _me = this;
      _me.loading = true;
      let params = {
        id: model.id
      };
      _me.$common
        .httpPost("/api/content/admin/category/delete", params)
        .then(res => {
          _me.loading = false;
          if (res.code === "1000000") {
            _me.$message.success("删除成功");
            _me.$common.removeGlobalStorage("contentStructureList");
            _me.getCategoryList();
          } else {
            _me.$message({
              message: res.message || "获取数据失败",
              type: "error"
            });
          }
        })
        .catch(err => {
          _me.loading = false;
          _me.$message({
            message: err || "获取数据失败",
            type: "error"
          });
        });
    },
    handleCurrentChange(val) {
      this.page_number = val;
      this.getCategoryList();
    }
  }
};
</script>

<style scoped>
</style>
